import { createActions, CreatedActions } from 'reduxsauce';

const { Types, Creators }: CreatedActions = createActions({
  fetchFormData: null,
  setFields: ['fields'],
  setFormStage: ['formStage'],
  fetchRelatedStations: null,
  setRelatedStations: ['relatedStations'],
  fetchSignedDocuments: ['onFinish'],
  setSignedDocuments: ['signedDocuments'],
  sendAnswers: ['answers', 'onFinish'],
  generateToken: ['hash', 'onFinish'],
  verifyToken: ['token', 'onFinish', 'onError'],
  uploadFile: ['formData', 'onFinish'],
  finishForm: ['onFinish'],
  clearData: null,
  downloadResource: ['uid', 'onFinish', 'resourceType'],
  setShouldRefreshConfirmation: ['shouldRefreshConfirmation'],
  getFile: ['name', 'url', 'id'],
});

export { Types as OfwcaPathTypes, Creators as OfwcaPathActions };
